import { Link, useParams } from 'react-router';
import { useAdminRun, useAdminUser } from '../api/admin';
import { RelativeTime } from '../components/RelativeTime';
import { StateBadge } from '../components/StateBadge';
import {
  AdminError,
  AdminSection,
  AdminShell,
  DetailList,
  AdminSkeletonRows,
  UserLink,
} from './adminShared';

export function AdminRunPage() {
  const { runId } = useParams<{ runId: string }>();
  const run = useAdminRun(runId);
  const owner = useAdminUser(run.data?.userId);
  const title = run.data ? `Run ${run.data.id}` : 'Run';

  return (
    <AdminShell title={title} subtitle={runId}>
      <AdminSection title="Run">
        {run.isPending && <AdminSkeletonRows rows={4} />}
        {run.error && (
          <AdminError subject="run" error={run.error} onRetry={() => void run.refetch()} />
        )}
        {run.data && (
          <DetailList
            rows={[
              ['State', <StateBadge state={run.data.state} />],
              [
                'Job',
                <Link to={`/admin/jobs/${run.data.jobId}`} className="font-mono text-xs underline">
                  {run.data.jobId}
                </Link>,
              ],
              ['User', <UserLink userId={run.data.userId} email={owner.data?.email} />],
              ['Retry count', run.data.retryCount],
              ['Created', <RelativeTime iso={run.data.createdAt} />],
              ['Updated', <RelativeTime iso={run.data.updatedAt} />],
            ]}
          />
        )}
      </AdminSection>
    </AdminShell>
  );
}
